import { Button, Form, Modal } from "react-bootstrap";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { RequiredMark } from "../FormFields";

interface Props {
  show: boolean;
  close: () => void;
  onSubmit: (args: { bundleJson?: File; version?: string }) => Promise<void> | void;
}

export function SubmitNewBundleModal({ show, close, onSubmit }: Props) {
  const [bundleJson, setBundleJson] = useState<File | undefined>();
  const [version, setVersion] = useState<string | undefined>();

  const handleFileChange = async (file: File | undefined) => {
    setBundleJson(file);
    setVersion(undefined);
    if (!file) return;
    try {
      const parsed = JSON.parse(await file.text());
      if (typeof parsed?.version !== "string" || parsed.version.trim() === "") {
        toast.error("Selected bundle JSON is missing a 'version' field.");
        return;
      }
      setVersion(parsed.version);
    } catch (e: any) {
      console.error(e.stack);
      toast.error("Selected file is not valid JSON.");
    }
  };

  return (
    <Modal show={show} onHide={close} size={"xl"}>
      <Modal.Header closeButton>
        Add Bundle
      </Modal.Header>

      <Modal.Body>
        <Form>
          <div>
            <Form.Label>Select Bundle JSON <RequiredMark /></Form.Label>
            <Form.Control
              aria-label="bundleFile"
              type="file"
              accept="application/json"
              multiple={false}
              onChange={(e) => {
                const input = e.target as HTMLInputElement;
                void handleFileChange(input.files?.[0]);
              }}
            />
          </div>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={close}>
          Cancel
        </Button>
        <Button
          variant="primary"
          type={"submit"}
          disabled={!bundleJson || !version}
          onClick={() => onSubmit({ bundleJson, version })}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
